export class PersonalsAccidentsQuoteEmailRequest {
    opportunityId: number;
    producerCuit: string;
    term: number;
    riskCategoryDescription: string;
    insuredGroupMembersQuantity: number;
    postalCode: number;
    isMotorcycle: true;
    paymentMethod: string;
    email: string;
    personalAccidentQuotes: Array<PersonalAccidentQuotes>;
}

export class PersonalAccidentQuotes {
    productKey: string;
    paymentFee: number;
    totalCost: number;
    monthlyCost: number;
}
